module.exports = __webpack_public_path__ + "img/fondo_ransa.e1229edf.png";